import { useNavigate, useLocation } from 'react-router-dom';

export default function LanguageToggle({ className = '', tone = 'silver' }) {
  const navigate = useNavigate();
  const { pathname, search, hash } = useLocation();
  const current = pathname.startsWith('/el') ? 'gr' : 'en';

  const setLng = (lng) => {
    if (lng === current) return;
    const stripped = pathname.replace(/^\/el(\/|$)/, '/');
    const target = lng === 'gr'
      ? (stripped === '/' ? '/el/' : `/el${stripped}`)
      : stripped;
    navigate(`${target}${search}${hash}`);
  };

  const colors = {
    silver: {
      active: 'text-silver-50',
      idle: 'text-silver-400 hover:text-silver-100',
      sep: 'text-silver-500/60',
    },
    burgundy: {
      active: 'text-burgundy-100',
      idle: 'text-burgundy-200/70 hover:text-burgundy-100',
      sep: 'text-burgundy-300/50',
    },
    paper: {
      active: 'text-ink-deeper',
      idle: 'text-ink-deeper/55 hover:text-ink-deeper',
      sep: 'text-ink-deeper/30',
    },
  }[tone] || {
    active: 'text-silver-50',
    idle: 'text-silver-400 hover:text-silver-100',
    sep: 'text-silver-500/60',
  };

  const item =
    'tracking-widest text-[0.72rem] uppercase transition-colors duration-300 ease-out-quart focus:outline-none focus-visible:underline underline-offset-4';

  return (
    <div
      className={`inline-flex items-center gap-2 select-none ${className}`}
      role="group"
      aria-label="Language selector"
    >
      <button
        type="button"
        onClick={() => setLng('en')}
        aria-pressed={current === 'en'}
        className={`${item} ${current === 'en' ? colors.active : colors.idle}`}
      >
        EN
      </button>
      <span className={`text-[0.7rem] ${colors.sep}`} aria-hidden>
        |
      </span>
      <button
        type="button"
        onClick={() => setLng('gr')}
        aria-pressed={current === 'gr'}
        className={`${item} ${current === 'gr' ? colors.active : colors.idle}`}
      >
        GR
      </button>
    </div>
  );
}
